import { zeztraApi } from '@ibk/shared-config';
export const zeztraContractApi = zeztraApi.injectEndpoints({
    endpoints: build => ({
        getValidateContract: build.query({
            query: () => ({
                url: '/v1/oauth/validation',
                method: 'GET',
            }),
            transformResponse: (response) => {
                return response;
            },
        }),
    }),
    overrideExisting: false,
});
export const { useLazyGetValidateContractQuery } = zeztraContractApi;
